import {getRequest, postRequest} from "../../src/api/index.js";
import {
    FORGOT_PASSWORD_ERROR,
    HOME, REGISTER_ERROR, REGISTER_INFO, REGISTER_INFO_ERROR,
    RESET_PASSWORD_ASSIGN_OTP,
    USER_PROFILE,
    USER_PROFILE_ERROR
} from "../../src/actions/types.js";

export const registerInfo = async (data, cb) => async (
    dispatch
) => {
    try {
        const res = await getRequest(`/user/retrieveuserinfo/` + data.id, "user", (status) => {
            return (status >= 200 && status < 300) || status === 400; // default
        });

        if (res.status !== 400) {
            dispatch({
                type: REGISTER_INFO,
                payload: res.data
            })

            cb(res.data);
        } else {
            dispatch({
                type: REGISTER_INFO_ERROR,
                payload: res.data.errors[0]
            });
        }
    } catch (err) {
        if (err.response) {
            // There is an error response from the server
            // You can anticipate error.response.data here
            if (err.response.data && err.response.data.errors[0]) {
                dispatch({
                    type: REGISTER_INFO_ERROR,
                    payload: err.response.data.errors[0]
                });
            } else {
                const error = err.response.data;
                dispatch({
                    type: REGISTER_INFO_ERROR,
                    payload: err.message
                });
            }
        } else if (err.request) {
            // The request was made but no response was received
            // Error details are stored in error.reqeust
            dispatch({
                type: REGISTER_INFO_ERROR,
                payload: err.request
            });
        } else if (err) {
            dispatch({
                type: REGISTER_INFO_ERROR,
                payload: err.message
            });
        } else {
            // Some other errors
            dispatch({
                type: REGISTER_INFO_ERROR,
                payload: "Something went wrong."
            });
        }
    }
};
